// This separate file is created to make sure tracing is included in a separate chunk
// https://github.com/getsentry/sentry-javascript/issues/10793#issuecomment-1960724903
import {
  addIntegration,
  getActiveSpan,
  reactRouterV6BrowserTracingIntegration,
  SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN,
  startInactiveSpan,
  withActiveSpan,
  wrapCreateBrowserRouter,
} from '@sentry/react';

const initTracing = (
  options: Parameters<typeof reactRouterV6BrowserTracingIntegration>[0],
) => {
  addIntegration(reactRouterV6BrowserTracingIntegration(options));
  window.SentryTracing = {
    wrapCreateBrowserRouter,
    getActiveSpan,
    startInactiveSpan,
    SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN,
    withActiveSpan,
  };
};

export default initTracing;
